import { render, staticRenderFns } from "./ShopMenuItemServiceMultiPackage.vue?vue&type=template&id=5fe09b38&"
import script from "./ShopMenuItemServiceMultiPackage.vue?vue&type=script&lang=ts&"
export * from "./ShopMenuItemServiceMultiPackage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports